<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li class="flex items-center ml-4">
              <router-link to="/systemEnum" class="mr-2 vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
              <h3>{{ $t("system.label.Edit") }} {{ enumName }}</h3>
            </li>
          </ul>
        </div>
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row mb-5">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-2/1">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Id')"
                  :key="resetKey"
                >
                  <vs-input
                    v-model="enumId"
                    :label="$t('system.label.Id')"
                    class="w-full mb-5 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-2/1">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Property')"
                  :key="resetKey"
                >
                  <vs-input
                    v-model="enumProperty"
                    :label="$t('system.label.Property')"
                    class="w-full mb-5 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-2/1">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Value')"
                  :key="resetKey"
                >
                  <vs-input
                    v-model="enumValue"
                    :label="$t('system.label.Value')"
                    class="w-full mb-5 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  class="mb-2 w-full createPlusBtn"
                  @click="editEnumCode"
                  >{{ $t("system.label.Add") }}</vs-button
                >
              </div>
            </div>
            <div
              class="vx-row"
              v-for="(codeValuesData, index) in this.viewEnumConfig"
              :key="index"
            >
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-2/1">
                <vs-input
                  v-model="codeValuesData.id"
                  class="w-full mb-5 font-semibold"
                  disabled
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-2/1">
                <vs-input
                  v-model="codeValuesData.type"
                  class="w-full mb-5 font-semibold"
                  disabled
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-2/1">
                <vs-input
                  v-model="codeValuesData.value"
                  class="w-full mb-5 font-semibold"
                  disabled
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                <feather-icon
                  icon="TrashIcon"
                  :title="$t('system.label.Delete')"
                  svgClasses="w-5 h-5 text-danger stroke-current cursor"
                  class="ml-2 mt-6 icon_row"
                  @click="deleteValueCodes(codeValuesData.id)"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      breadcrumbs: [
        { name: "System", to: "" },
        { name: this.$t("ENUM"), to: "/systemEnum" },
        {
          name: `${this.$t("system.label.View")}  ${this.$route.params.name}`,
          to: `/viewEnum/${this.$route.params.name}`,
        },
        {
          name: `${this.$t("system.label.Edit")}  ${this.$route.params.name}`,
          to: "/",
        },
      ],
      resetKey: 0,
      enumId: "",
      enumProperty: "",
      enumValue: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      viewEnumConfig: (state) => state.configuration.viewEnumConfig,
    }),
  },
  methods: {
    async deleteValueCodes(id) {
      const data2 = {
        name: this.enumName,
        id: id,
      };
      try {
        await this.$store.dispatch("configuration/deleteEnumByIdAction", data2);
        await this.enumDataByName();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editEnumCode() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const idExists = this.viewEnumConfig.some(
        (item) => item.id === parseInt(this.enumId)
      );
      const propertyExists = this.viewEnumConfig.some(
        (item) => item.type.toLowerCase() === this.enumProperty.toLowerCase()
      );
      if (idExists) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Duplicate ID, Please use unique ID",
          type: "error",
        });
        return;
      }
      if (propertyExists) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Property Already Exist",
          type: "error",
        });
        return;
      }
      const payload = {
        enumName: this.enumName,
        enumId: this.enumId,
        enumMessageProperty: this.enumProperty,
        enumValue: this.enumValue,
      };
      try {
        await this.$store.dispatch("configuration/createEnumAction", payload);
        await this.enumDataByName();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetForm() {
      this.enumId = "";
      this.enumProperty = "";
      this.enumValue = "";
    },
    async enumDataByName() {
      try {
        await this.$store.dispatch(
          "configuration/fetchViewEnumData",
          this.enumName
        );
      } catch (error) {
        error;
      }
    },
  },

  created() {
    this.enumName = this.$route.params.name;
    this.enumDataByName();
  },
};
</script>
<style scoped>
.createPlusBtn {
  top: 14px;
  height: 39px;
}
</style>
